import bathiya from '../../../assets/bathiya.jpg';
import bimal from '../../../assets/bimal.jpeg';
import charlie from '../../../assets/charlie.jpeg';
import elon from '../../../assets/elon.jpeg';
import robert from '../../../assets/robert-downey-jr.jpeg';
import sel1 from '../../../assets/selena.png';

export default [
	{
		firstName: 'Selena',
		lastName: 'Gomaz',
		designation: 'Singer',
		image: sel1,
		color: '#e4e4e4',
	},
	{
		firstName: 'Elon',
		lastName: 'Musk',
		designation: 'CEO',
		image: elon,
		color: '#af2332',
	},
	{
		firstName: 'Robert',
		lastName: 'Downey Jr',
		designation: 'Iron Man',
		image: robert,
		color: '#f7f334',
	},
	{
		firstName: 'Charlie',
		lastName: 'Puth',
		designation: 'Singer',
		image: charlie,
		color: '#34f775',
	},
	{
		firstName: 'Bimal',
		lastName: 'Jayakody',
		image: bimal,
		designation: 'Actor',
		color: '#f7f334',
	},
	{
		firstName: 'Bathiya',
		lastName: 'Jayakody',
		image: bathiya,
		designation: 'Singer',
		color: '#f7f334',
	},
];
